module.exports = __webpack_public_path__ + "static/media/map-marker-smile.42e7298e.svg";